
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'


import { Core } from '../core/core'

import { SeTagComponent } from './tag.component'

@NgModule({
  imports: [
	CommonModule
  ],
  declarations: [
    SeTagComponent
  ],
  exports: [
    SeTagComponent,
  ],
})
export class SeTagModule {}

export const SE_TAG_MODULE_BUNDLE = `${Core.ANGULAR_MODULE}.tag`

